var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-vue"},[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-content"},[_c('div',{staticClass:"login-title"},[_vm._v("华盛云财务")]),_c(_vm.currentComponent,{tag:"component",model:{value:(_vm.currentComponent),callback:function ($$v) {_vm.currentComponent=$$v},expression:"currentComponent"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }